// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1c-q";
export var animationRelative = "_1c-p";
export var backdropBlur = "_1c-0";
export var detailLabelCell = "_1c-12";
export var detailTable = "_1c-11";
export var detailValueCell = "_1c-13";
export var docIconBox = "_1c-1d";
export var docIconBoxMd = "_1c-1f";
export var docIconBoxSm = "_1c-1e";
export var docTypeRow = "_1c-16";
export var docTypeRowInner = "_1c-17";
export var dropdownMatchDatePicker = "_1c-3";
export var evidenceCardContent = "_1c-1c";
export var fileUploadSpin = "_1c-j";
export var gorgiasOpenButton = "_1c-15 _1c-d";
export var gorgiasTicketCard = "_1c-14";
export var heroModalFooterButton = "_1c-18";
export var hiddenContainer = "_1c-o";
export var iconPrimary = "_1c-1g";
export var iconQuaternary = "_1c-1i";
export var iconTertiary = "_1c-1h";
export var integrationCard = "_1c-1";
export var integrationLogoBox = "_1c-2";
export var mainColumnSticky = "_1c-1b";
export var maxWidthContainer = "_1c-19";
export var modalContentBody = "_1c-a";
export var modalHeaderImage = "_1c-5";
export var modalImageLabel = "_1c-7";
export var modalImageOverlay = "_1c-6";
export var modalImageSubtitle = "_1c-9";
export var modalImageTitle = "_1c-8";
export var modalImageWrapper = "_1c-4";
export var modalStickyFooter = "_1c-b";
export var removeButton = "_1c-e";
export var sidebarColumn = "_1c-1a";
export var spinner = "_1c-i";
export var timelineLine = "_1c-y";
export var timelineLineBlack = "_1c-10 _1c-y";
export var timelineLineGray = "_1c-z _1c-y";
export var timelineLineHeight = "_1c-x";
export var tlDotActivate = "_1c-u";
export var tlDotActivateAnim = "_1c-t";
export var tlDotHide = "_1c-s";
export var tlDotHideAnim = "_1c-r";
export var tlLineActivate = "_1c-w";
export var tlLineActivateAnim = "_1c-v";
export var uploadHint = "_1c-n";
export var uploadIconBox = "_1c-k";
export var uploadLabel = "_1c-m";
export var uploadText = "_1c-l";
export var uploadZone = "_1c-f";
export var uploadZoneCursorDefault = "_1c-h";
export var uploadZoneCursorPointer = "_1c-g";
export var uploadedFileRow = "_1c-c";
export var viewButton = "_1c-d";